import React from 'react';
import { captureUiError } from '../utils/errorTracking';

class StripeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    captureUiError(error, 'billing.render');
    // Log the error for debugging
    console.error('[StripeErrorBoundary] Caught an error in Stripe component:', error, errorInfo);

    // Check if this is the specific Stripe tab error
    if (error?.message?.includes('customFillData') || error?.stack?.includes('tab')) {
      console.error(
        '[StripeErrorBoundary] Detected Stripe tabs layout error - this may be due to PaymentElement configuration',
      );
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="stripe-error-fallback"
          style={{
            padding: '20px',
            border: '1px solid #e74c3c',
            borderRadius: '8px',
            backgroundColor: '#fdf2f2',
            color: '#e74c3c',
            textAlign: 'center',
          }}
        >
          <h4>⚠️ Payment Form Error</h4>
          <p>The payment form encountered an error and couldn't load properly.</p>
          <p>Please refresh the page and try again.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              backgroundColor: '#e74c3c',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              marginTop: '10px',
            }}
          >
            Refresh Page
          </button>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '10px', textAlign: 'left' }}>
              <summary>Error Details (Development Only)</summary>
              <pre style={{ fontSize: '12px', whiteSpace: 'pre-wrap' }}>
                {this.state.error?.stack || this.state.error?.message}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default StripeErrorBoundary;
